export default __webpack_public_path__ + "static/media/vimeo.709b1a25.svg";